import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-hub-help-dialog',
  imports: [],
  templateUrl: './hub-help-dialog.component.html',
  styleUrl: './hub-help-dialog.component.scss'
})
export class HubHelpDialogComponent {
    private matDialog: MatDialog = inject(MatDialog);

    public closeDialog(): void {
        this.matDialog.closeAll();
    }
}
